import type { CityConfig } from "../city-template/types";

export const hannibalConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hannibal",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "hannibal",
  route: "/hannibal",
  title: "Emergency Passport Hannibal, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hannibal, MO — as fast as 24 hours. Serving Marion County and Northeast Missouri — Mark Twain's hometown. A+ BBB rated registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Hannibal, MO",
  heroSubtitle: "Mark Twain festival visitors from Germany and your passport is expiring? Northeast Missouri business trip to Toronto in ten days? Mississippi River cruise from Dubuque and the kids need documents? We help Hannibal residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Hannibal%20Missouri%20with%20Mark%20Twain%20boyhood%20home%20white%20picket%20fence%20and%20Mississippi%20River%20in%20the%20background%20at%20golden%20hour%20warm%20autumn%20light%20brick%20buildings%20tree-lined%20Main%20Street%20charming%20river%20town%20atmosphere%20professional%20photography%20nostalgic%20Americana&width=1800&height=700&seq=hannibal-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Historic downtown Hannibal Missouri with Mark Twain boyhood home at golden hour on the Mississippi River",
  geoPosition: "39.7084;-91.3585",
  geoPlacename: "Hannibal, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 320 miles northeast of Hannibal via I-72/I-55",
  },
  nearbyCitiesZips: [
    { name: "Hannibal", zips: "63401, 63402" },
    { name: "Quincy", zips: "62301, 62305" },
    { name: "Palmyra", zips: "63461" },
    { name: "Monroe City", zips: "63456" },
    { name: "Bowling Green", zips: "63334" },
    { name: "Louisiana", zips: "63353" },
    { name: "New London", zips: "63459" },
    { name: "Vandalia", zips: "63382" },
    { name: "Mexico", zips: "65265" },
    { name: "Moberly", zips: "65270" },
    { name: "Macon", zips: "63552" },
    { name: "Kirksville", zips: "63501" },
    { name: "Keokuk", zips: "52632" },
    { name: "Canton", zips: "63435" },
    { name: "Shelbina", zips: "63468" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Northeast Missouri departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Mark Twain Country", desc: "Serving Hannibal, Quincy, Palmyra, and Northeast Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Louis, MO", route: "/st-louis" },
    { name: "Fast passport renewal in Columbia, MO", route: "/columbia-mo" },
    { name: "Emergency passport help in Kansas City, MO", route: "/kansas-city" },
    { name: "Urgent passport services in Quincy, IL", route: "/quincy-il" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Burlington, IA", route: "/burlington-ia" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hannibal remotely via secure courier. We do not have a walk-in office in Hannibal — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Marion County and Northeast Missouri.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Marion County and Northeast Missouri including Palmyra, Monroe City, Louisiana, Bowling Green, and the Tri-State area",
  serviceAreaIntro: "From the Mark Twain Boyhood Home and historic Main Street to the Mississippi River bluffs and Lovers Leap, from the county seat of Palmyra to the charming town squares of Monroe City and Bowling Green, from the industrial energy of Louisiana to the agricultural communities of New London and Vandalia — Fast Passport Center serves the entire Northeast Missouri and Tri-State region. We regularly help Twain festival visitors, Hannibal-LaGrange University travelers, and families across Marion County get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Hannibal neighborhoods and the surrounding Northeast Missouri and Tri-State area including Quincy, Palmyra, Monroe City, Bowling Green, Louisiana, New London, Vandalia, Mexico, Moberly, Macon, Kirksville, Keokuk, and Canton. If you are anywhere in Marion County or the Mississippi River Valley, we have you covered.",
  howItWorksIntro: "Most Hannibal travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Hannibal travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Hannibal and Marion County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hannibal? Here are the most common ones we hear from Northeast Missouri travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/motor-vehicle/",
  dmvLabel: "Missouri DOR — Motor Vehicle & Driver Licensing",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Hannibal travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Carol S.",
      location: "Hannibal, MO",
      rating: 5,
      text: "Mark Twain festival delegates from Germany were arriving and I realized my passport expired. Fast Passport Center got it in 29 hours. Twain would've written a story about it!",
      service: "Passport Renewal",
    },
    {
      name: "Bill M.",
      location: "Palmyra, MO",
      rating: 5,
      text: "Medical emergency trip to Toronto. Fast Passport Center got my passport in 25 hours. The dedicated agent was incredible — called me every few hours with updates. Northeast Missouri's hidden gem.",
      service: "Emergency Passport",
    },
    {
      name: "Megan D.",
      location: "Quincy, IL",
      rating: 5,
      text: "Tri-State family cruise to the Bahamas and the kids needed first passports. Fast Passport Center walked us through everything and got them in 4 days. Lifesavers for Mississippi River families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "hannibal-1",
      name: "Hannibal Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "801 Broadway",
      city: "Hannibal",
      state: "MO",
      zip: "63401",
      phone: "(573) 221-0219",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Hannibal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hannibal facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "hannibal-2",
      name: "Marion County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "100 S Main St, Suite 102",
      city: "Palmyra",
      state: "MO",
      zip: "63461",
      phone: "(573) 769-2549",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles west of Hannibal in Palmyra",
      website: "https://www.marioncounty-mo.gov/county-clerk",
      websiteLabel: "Marion County Clerk",
      notes: "Accepts passport applications at the county seat in Palmyra. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "hannibal-3",
      name: "Quincy Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3535 Locust St",
      city: "Quincy",
      state: "IL",
      zip: "62301",
      phone: "(217) 222-0610",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southeast of Hannibal across the Mississippi",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Quincy and Adams County. Full passport services available. Cross-river option for Hannibal residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hannibal-4",
      name: "Louisiana Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Georgia St",
      city: "Louisiana",
      state: "MO",
      zip: "63353",
      phone: "(573) 754-4618",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles south of Hannibal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Louisiana and Pike County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "hannibal-5",
      name: "Moberly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "415 N Williams St",
      city: "Moberly",
      state: "MO",
      zip: "65270",
      phone: "(660) 263-3874",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles southwest of Hannibal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Moberly and Randolph County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hannibal photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Marion County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hannibal applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Marion County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hannibal travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hannibal." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hannibal address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hannibal before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hannibal for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Hannibal?", a: "Fast Passport Center offers fast passport renewal in Hannibal in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Hannibal?", a: "The nearest regional passport agency to Hannibal is the Chicago Passport Agency, approximately 320 miles northeast via I-72/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Hannibal without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Hannibal?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Hannibal — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Marion County and Northeast Missouri residents." },
    { q: "Do you serve the entire Northeast Missouri and Tri-State region?", a: "Absolutely. Fast Passport Center serves the entire Northeast Missouri and Tri-State region including Hannibal, Quincy, Palmyra, Monroe City, Bowling Green, Louisiana, New London, Vandalia, Mexico, Moberly, and surrounding areas. Our courier service works seamlessly from any address in Marion County." },
    { q: "Can I expedite a child passport in Hannibal?", a: "Yes. Fast Passport Center expedites child passports in Hannibal for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Northeast Missouri families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hannibal with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Hannibal", address: "3650 Stardust Dr, Hannibal, MO 63401", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "Walgreens — Hannibal", address: "120 Steamboat Bend, Hannibal, MO 63401", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "Walmart Supercenter — Quincy", address: "5211 Broadway St, Quincy, IL 62305", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "CVS Pharmacy — Quincy", address: "3700 Broadway St, Quincy, IL 62301", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Hannibal",
      address: "5630 Veterans Rd, Hannibal, MO 63401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Mexico",
      address: "101 N Jefferson St, Mexico, MO 65265",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Audrain County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Illinois SOS — Quincy",
      address: "3701 E Lake Centre Dr, Quincy, IL 62305",
      hours: "Mon–Fri: 8AM–5:30PM",
      note: "Serves Adams County IL. REAL ID available. Cross-river option for Hannibal residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "UIN",
      name: "Quincy Regional Airport",
      distance: "25 miles southeast of Hannibal",
      address: "1647 Highway 104, Quincy, IL 62305",
      note: "Regional airport with scheduled flights to Chicago and St. Louis. About 30 minutes from Hannibal across the Mississippi River.",
      flightUrl: "https://www.quincyil.gov/city-government/departments/airport",
      flightLabel: "UIN Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "115 miles south of Hannibal",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international hub. About 2 hours from Hannibal via I-61/I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "320 miles northeast of Hannibal",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway. About 5 hours from Hannibal via I-72/I-55.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
  ],
};